import classnames from 'classnames';

import Skeleton from 'components/Skeleton';
import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';
import useStyles from './styles';

const AppDownloadSectionFallback = () => {
  const styles = useStyles({ titleColor: '' });

  return (
    <HorizontalContainerWrapper>
      <Skeleton className={classnames(styles.root, styles.rootSkeleton)} />
    </HorizontalContainerWrapper>
  );
};

export default AppDownloadSectionFallback;
